/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-sequences */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Myteams.css";
import { Tabs, Button, Row, Col, Drawer, Pagination } from "antd";
import {
  getPendingTeamMembers,
  getActiveTeamMembers,
  getInActiveTeamMembers,
} from "../../redux/actions";
import history from "../../routes/history";
import Search_Bar from "./components/searchbar";
import EmployerCard from "./components/EmployerCard";
import Add_Member from "./components/Add Member";
import Loader from "../../components/Loading/Loader";
import emptyjobs from "../../assets/img/EmptyJobs3.png";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import SinglePagination from "./../../components/Pagination/SinglePagination";

export default function MyTeams(props) {
  const PAGE_SIZE = 10;
  const { TabPane } = Tabs;
  const location = useLocation();

  const [showModal, setShowModal] = useState();
  const [Active, setActive] = useState([]);
  const [Pending, setPending] = useState([]);
  const [Inactive, setInactive] = useState([]);
  const [ActiveData, setActiveData] = useState([]);
  const [PendingData, setPendingData] = useState([]);
  const [InactiveData, setInactiveData] = useState([]);
  const [defaultKey, setDefaultKey] = useState("1");
  const [activePage, setActivePage] = useState(1);
  const [inActivePage, setInActivePage] = useState(1);
  const [pendingPage, setPendingPage] = useState(1);
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [key, setKey] = useState("1");

  const profile = JSON.parse(localStorage.getItem("userProfile"));
  const MasterId = profile.MasterAccountId;

  // REDux Data
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.TeamMembersReducer.loading);
  // const details = useSelector((state) => state.TeamMembersReducer.details);
  const active = useSelector((state) => state.TeamMembersReducer.active);
  const inActive = useSelector((state) => state.TeamMembersReducer.inactive);
  const pending = useSelector((state) => state.TeamMembersReducer.pending);

  const success_ = useSelector((state) => state.TeamMembersReducer.success);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    setKey(location?.state?.defaultActiveKey || "1");
    if (location?.state?.defaultActiveKey === "2") {
      dispatch(getPendingTeamMembers({ page: 1, limit: PAGE_SIZE }));
    } else if (location?.state?.defaultActiveKey === "3") {
      dispatch(getInActiveTeamMembers({ page: 1, limit: PAGE_SIZE }));
    } else {
      dispatch(getActiveTeamMembers({ page: 1, limit: PAGE_SIZE }));
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (key === "1") {
      dispatch(getActiveTeamMembers({ page: activePage, limit: PAGE_SIZE }));
    } else if (key === "2") {
      dispatch(getPendingTeamMembers({ page: pendingPage, limit: PAGE_SIZE }));
    } else if (key === "3") {
      dispatch(getInActiveTeamMembers({ page: inActivePage, limit: PAGE_SIZE }));
    }
  }, [success_, key, activePage, pendingPage, inActivePage]);

  useEffect(() => {
    setActive(active.Active);
    setActiveData(active.Active);
    setInactive(inActive.InActive);
    setInactiveData(inActive.InActive);
    setPending(pending.Pending);
    setPendingData(pending.Pending);
  }, [active, inActive, pending]);

  function callback(key) {
    setKey(key);
    if (key === "1") {
      setActivePage(1);
    } else if (key === "2") {
      setPendingPage(1);
    } else if (key === "3") {
      setInActivePage(1);
    }
  }

  const customCloseIcon = (
    <div style={{ position: "absolute", top: "20px", right: "20px" }}>
      <CloseOutlined />
    </div>
  );

  const handleActiveTabPageChange = (page) => {
    setActivePage(page);
    setKey("1"); 
  };
  
  const handlePendingTabPageChange = (page) => {
    setPendingPage(page);
    setKey("2"); 
  };
  
  const handleInactiveTabPageChange = (page) => {
    setInActivePage(page);
    setKey("3");
  };

  return (
    <div className="myteam-container">
      {Dimensions.width < 768 && (
        <Drawer
          className="add-Team-Member"
          title={<div className="add-team-title">Add New Team Member</div>}
          open={showModal}
          onClose={() => {
            handleActiveTabPageChange(1);
            handleInactiveTabPageChange(1);
            handlePendingTabPageChange(1);
            setShowModal(false);
          }}
          closeIcon={customCloseIcon}
          placement="top"
          footer={null}
          width={600}
          height={"80vh"}
        >
          <Add_Member setShowModal={setShowModal} />
          <Button
            className="button-cancel1"
            onClick={() => setShowModal(false)}
            style={{
              marginLeft: Dimensions.width < 768 && "24px",
              marginTop: -30,
            }}
          >
            Cancel
          </Button>
        </Drawer>
      )}
      {loading ? (
        <div>
          {" "}
          <Loader />{" "}
        </div>
      ) : (
        <>
          <Row
            style={{
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "17px",
            }}
          >
            <div>
              <div className="My-teams">My Team</div>

              {Dimensions.width > 768 &&
                (ActiveData?.length ||
                PendingData?.length ||
                InactiveData?.length ? (
                  <div className="Myteam-item">
                    {ActiveData?.length +
                      PendingData?.length +
                      InactiveData?.length}{" "}
                    Members
                  </div>
                ) : (
                  <div className="Myteam-item">0 Members</div>
                ))}
            </div>
            {!MasterId && (
              <button
                disabled={MasterId}
                className="team-per-button"
                onClick={() =>
                  Dimensions.width < 769
                    ? setShowModal(true)
                    : history.push("/myteams/addmember")
                }
              >
                <div style={{ fontSize: "16px", width: "2.7rem" }}>
                  <PlusOutlined />
                </div>
                Add New Team Member
              </button>
            )}
          </Row>
          <Tabs
            className="Myteam-tabs"
            activeKey={key}
            onChange={callback}
            tabBarGutter={50}
            size="small"
            tabBarExtraContent=""
            defaultActiveKey={defaultKey} //"1"
            style={{ color: "#7e7e7e" }}
          >
            <TabPane
              tab={
                ActiveData?.length
                  ? `Active(${active?.totalMembers})`
                  : "Active"
              }
              key="1"
            >
              {ActiveData?.length ? (
                <Search_Bar
                  data={Active}
                  setData={setActive}
                  ActualData={ActiveData}
                />
              ) : null}
              <Row className="Card-row" gutter={15}>
                {Active?.length > 0 ? (
                  <>
                    {Active?.map((items, index) => {
                      return (
                        <Col lg={8} md={8} sm={8} xs={24} key={index}>
                          <EmployerCard items={items} Status="Active" />
                        </Col>
                      );
                    })}
                    <Col
                      span={24}
                      mt={10}
                      style={{ textAlign: "center", marginTop: "10px  " }}
                    >
                      <SinglePagination
                        current={activePage}
                        total={active?.totalMembers}
                        pageSize={PAGE_SIZE}
                        onChange={handleActiveTabPageChange}
                        dimensions={Dimensions?.width}
                      />
                    </Col>
                  </>
                ) : (
                  <div className="noteam">
                    <img
                      src={emptyjobs}
                      alt="no-jobsimg"
                      className="joblisting-noimg"
                      style={{ width: "10rem", height: "10rem" }}
                    ></img>

                    <div className="joblisting-noimg">No Data</div>
                  </div>
                )}
              </Row>
            </TabPane>

            <TabPane
              disabled={MasterId}
              tab={
                InactiveData?.length
                  ? `Inactive(${InactiveData?.length})`
                  : "Inactive"

                //   `Inactive(${
                //   InactiveData?.length ? InactiveData?.length : "0"
                // })`
              }
              key="3"
            >
              {InactiveData?.length ? (
                <Search_Bar
                  data={Inactive}
                  setData={setInactive}
                  ActualData={InactiveData}
                />
              ) : null}

              <Row className="Card-row" gutter={15}>
                {Inactive?.length > 0 ? (
                  <>
                    {Inactive?.map((items, index) => {
                      return (
                        <Col lg={8} md={8} sm={8} xs={24} key={index}>
                          <EmployerCard items={items} Status="Inactive" />
                        </Col>
                      );
                    })}
                    <Col
                      span={24}
                      mt={10}
                      style={{ textAlign: "center", marginTop: "10px  " }}
                    >
                      <SinglePagination
                        current={inActivePage}
                        total={inActive?.totalInActiveMembers}
                        pageSize={PAGE_SIZE}
                        onChange={handleInactiveTabPageChange}
                        dimensions={Dimensions?.width}
                      />
                    </Col>
                  </>
                ) : (
                  <div className="noteam">
                    <img
                      src={emptyjobs}
                      alt="no-jobsimg"
                      className="joblisting-noimg"
                      style={{ width: "10rem", height: "10rem" }}
                    ></img>

                    <div className="joblisting-noimg">
                      No Data {/* You have no Inactive Members */}
                    </div>
                  </div>
                )}
              </Row>
            </TabPane>
            <TabPane
              disabled={MasterId}
              tab={
                PendingData?.length
                  ? `Pending(${pending?.totalPendingCount})`
                  : "Pending"
                //   `Pending(${
                //   PendingData?.length ? PendingData?.length : "0"
                // })`
              }
              key="2"
            >
              {PendingData?.length ? (
                <Search_Bar
                  data={Pending}
                  setData={setPending}
                  ActualData={PendingData}
                />
              ) : null}
              <Row className="Card-row" gutter={15}>
                {Pending?.length > 0 ? (
                  <>
                    {Pending?.map((items, index) => {
                      return (
                        <Col lg={8} md={8} sm={8} xs={24} key={index}>
                          <EmployerCard items={items} Status="Pending" />
                        </Col>
                      );
                    })}
                    <Col
                      span={24}
                      mt={10}
                      style={{ textAlign: "center", marginTop: "10px  " }}
                    >
                      <SinglePagination
                        current={pendingPage}
                        total={pending?.totalPendingCount}
                        pageSize={PAGE_SIZE}
                        onChange={handlePendingTabPageChange}
                        dimensions={Dimensions?.width}
                      />
                    </Col>
                  </>
                ) : (
                  <div className="noteam">
                    <img
                      src={emptyjobs}
                      alt="no-jobsimg"
                      className="joblisting-noimg"
                      style={{ width: "10rem", height: "10rem" }}
                    ></img>

                    <div className="joblisting-noimg">No Data</div>
                  </div>
                )}
              </Row>
            </TabPane>
          </Tabs>
        </>
      )}
    </div>
  );
}
